import jwtDecode from 'jwt-decode';
// routes
import { PATH_AUTH } from '../routes/paths';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode<{ exp: number }>(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const handleTokenExpired = (exp: number) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');

    sessionStorage.removeItem('accessToken');

    window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

const setSession = (accessToken: string | null) => {
  if (accessToken) {
    sessionStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axios.defaults.headers.common['Ced-Source-Name'] = 'shopline';
    axios.defaults.headers.common['Ced-Target-Name'] = 'hubspot';
    axios.defaults.headers.common.appCode = `eyJzaG9wbGluZSI6InNob3BsaW5lIiwiaHVic3BvdCI6Imh1YnNwb3QifQ==`;
    axios.defaults.headers.common.appTag = `shopline_hubspot`;

    // This function below will handle when token is expired
    // const { exp } = jwtDecode<{ exp: number }>(accessToken); // ~3 days by minimals server
    // handleTokenExpired(exp);
  } else {
    sessionStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common['Ced-Source-Name'];
    delete axios.defaults.headers.common['Ced-Target-Name'];
    delete axios.defaults.headers.common.appCode;
    delete axios.defaults.headers.common.appTag;
  }
};

export { isValidToken, setSession };
